import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';
import { SummaryItem, SummaryItemType } from '../../models';

interface SummaryDisplay {
  value: string;
  limit: string | null;
  tooltip: string | null;
  isComposite: boolean;
}

@Component({
  selector: 'app-summary-cards',
  standalone: true,
  imports: [CommonModule, TooltipModule],
  templateUrl: './summary-cards.component.html',
  styleUrls: ['./summary-cards.component.scss'],
})
export class SummaryCardsComponent {
  @Input() items: SummaryItem[] = [];
  @Input() currencyCode = 'RUB';

  get visibleItems(): SummaryItem[] {
    return (this.items ?? []).filter((item) =>
      item.visible ? item.visible() : true,
    );
  }

  resolveDisplay(item: SummaryItem): SummaryDisplay {
    const value = this.formatValue(item.value, item.type);
    const limit = item.limit != null
      ? this.formatValue(item.limit, item.type)
      : null;
    const tooltip = item.tooltip?.trim() || null;
    const isComposite = limit != null
      && !this.isEmpty(value)
      && !this.isEmpty(limit);

    return {
      value: isComposite || !this.isEmpty(value) || !limit
        ? value
        : limit,
      limit: isComposite ? limit : null,
      tooltip,
      isComposite,
    };
  }

  private isEmpty(value: string): boolean {
    return value === '' || value === '—';
  }

  private formatValue(
    value: number | null | undefined,
    type: SummaryItemType,
  ): string {
    if (value == null) {
      return type === 'money' ? '—' : '0';
    }

    if (type === 'money') {
      return new Intl.NumberFormat('ru-RU', {
        style: 'currency',
        currency: this.currencyCode,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(value);
    }

    return String(value);
  }
}
